'use client'

import React from 'react'

import TextQuote from '../../../organisms/Text/variants/TextQuote.component'

import * as S from '../PostBody.styles'

const BodyQuote = ({ colorScheme, quote }) => {
  return quote ? (
    <TextQuote quote={quote} colorScheme={colorScheme} />
  ) : null
}

export default BodyQuote
